import * as React from 'react';
import Moment from 'react-moment';
import { RouteComponentProps } from 'react-router';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import BusStopService from '../../../api/stadtbus/bus_stop_service';
import PredictionsService from '../../../api/stadtbus/predictions_service';
import { decodeTripId } from '../../../helpers';
import { IPrediction } from '../../../interfaces/stadtbus/predictions'
import { lazyInject } from '../../../inversify';
import ObserverComponent from '../../observer_component';
import Theme from '../css/bustheme';
import { LineEndImage, LineMainImage, LineNormalImage, LineStartImage } from '../line_images';

interface IProps {
  tripID: string,
  stopID: string,
}

interface ILinieComponentProps extends Partial<RouteComponentProps<IProps>> {
}

interface ILinieComponentState {
  isLoading: boolean,
  lineDestination: string,
  lineName: string,
  stopID: string,
  journeyRef: string,
  operationDate: string,
  tripPredictions: IPrediction[]
}

class LinieComponent extends React.Component<ILinieComponentProps, ILinieComponentState> {
  @lazyInject(Theme)
  private readonly theme: Theme;
  @lazyInject(PredictionsService)
  private readonly predictionsService: PredictionsService;
  @lazyInject(BusStopService)
  private readonly busStopService: BusStopService;

  private predictionsSubscription: Subscription;

  constructor(props: ILinieComponentProps) {
    super(props);

    const id = decodeTripId(this.props.match!.params.tripID);

    this.state = {
      isLoading: true,
      journeyRef: id[0],
      lineDestination: "",
      lineName: "",
      operationDate: id[1],
      stopID: this.props.match!.params.stopID,
      tripPredictions: [],
    };
  }

  public render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <h2 style={{ marginTop: "8px" }}>Linie:</h2>
          </div>
        </div>
        <div className="row" style={{ marginTop: "8px" }}>
          <div className="panel panel-default">
            <div className="panel-heading">
              {(!this.state.isLoading) ? (
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div className={"circleSmall " + this.theme.getLineColor(this.state.lineName)}>
                          {this.state.lineName}
                        </div>
                      </td>
                      <td style={{ padding: "16px", fontSize: "18px", width: "100%" }}>
                        {this.state.lineDestination}
                      </td>
                      <td/>
                    </tr>
                  </tbody>
                </table>
              ) : (<div />)}
            </div>
            <div className="panel-body">
              {(!this.state.isLoading) ? (
                <table>
                  <thead>
                    <tr>
                      <th />
                      <th style={{ paddingLeft: "16px", fontSize: "18px" }}>
                        Haltestelle
                      </th>
                      <th style={{ paddingRight: "8px", fontSize: "18px" }}>
                        Abfahrt (+Versp.)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.tripPredictions.map((busStop: IPrediction) => (
                      <tr key={busStop.stopID} className="clickable" onClick={e => this.showBusStop(busStop.stopID)} title="Zeige Haltestelle an">
                        <td>
                          {this.getLineImage(busStop)}
                        </td>
                        <td style={{ paddingLeft: "16px", fontSize: "18px", width: "100%", color: (busStop.visited ? 'gray' : 'black') }}>
                          <ObserverComponent>{this.busStopService.onBusStop(busStop.stopID).pipe(map(s => s.name))}</ObserverComponent>
                        </td>
                        <td style={{ paddingRight: "8px", fontSize: "18px", whiteSpace: "nowrap" }}>
                          {!busStop.visited ? (
                            <div >
                              <Moment format='HH:mm' date={busStop.shouldTime} />
                              {(busStop.isRealTime) ?
                                <div style={{marginLeft: "8px", color: busStop.delay > 0 ? "red" : "green", display: "inline"}}>
                                  +{busStop.delay}
                                </div>
                                : <div/>
                              }
                            </div>
                          ) : ''}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (<div />)}
            </div>
          </div>
        </div>
      </div>
    );
  }

  public componentDidMount() {
    this.predictionsSubscription = this.predictionsService
      .onTripPredictions(this.state.journeyRef, this.state.operationDate)
      .subscribe((tripPredictions: IPrediction[]) => {
        if (tripPredictions.length > 0) {
          this.setState({
            isLoading: false,
            lineDestination: tripPredictions[0].lineDestination,
            lineName: tripPredictions[0].lineName,
            tripPredictions,
          });
        }
      });
  }

  public componentWillUnmount() {
    this.predictionsSubscription.unsubscribe();
  }

  private showBusStop(stopID: string): void {
    if (this.props.history && stopID) {
      this.props.history.push('/stadtbus/haltestellen/' + stopID);
    }
  }

  private getLineImage(prediction: IPrediction): JSX.Element {
    const active = this.state.tripPredictions.find(p => !p.visited) === prediction;

    const index = this.state.tripPredictions.findIndex(p => p === prediction);

    if (index === 0) {
      return <LineStartImage active={active}/>;
    } else if (index === this.state.tripPredictions.length - 1) {
      return <LineEndImage active={active}/>;
    } else if (prediction.stopID === '2044') {
      return <LineMainImage active={active}/>;
    }

    return <LineNormalImage active={active}/>;
  }
}

export default LinieComponent;



// WEBPACK FOOTER //
// ./src/components/stadtbus/fahrgast_components/linie_component.tsx